/**
 * Motion 11 · Live value change. First paint shows the snapshot value (no count-up).
 * When a delta changes the value, roll old → new with WAAPI. No React re-render.
 */
import { useRef } from "react";
import { meetingStore, type MeetingState } from "../../stores/meetingStore";
import { useStoreEffect } from "../../hooks/useStoreEffect";
import { easing, prefersReducedMotion, recipes } from "../../motion";

export function LiveNumber({ select, format = String }: {
  select: (s: MeetingState) => number | string | undefined;
  format?: (v: number | string) => string;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const initial = select(meetingStore.getState());

  useStoreEffect(meetingStore, select, (v, prev) => {
    const el = ref.current;
    if (!el || v === undefined || v === prev) return;
    el.textContent = format(v);
    if (prefersReducedMotion()) return;
    el.animate(
      [{ transform: "translateY(60%)", opacity: 0 }, { transform: "translateY(0)", opacity: 1 }],
      { duration: recipes.liveValueChange.duration, easing: easing.standard },
    );
  }, { fireImmediately: false });

  return <span ref={ref} className="live-number">{initial === undefined ? "—" : format(initial)}</span>;
}
